import React from "react";

//CSS
import "./Header.scss";

const Header = () => {
  
  return (
    <>
      <header>
        <div className="main-container header-login-container">
          <div className="header-login-container-main">
            <div className="header-login-container-left">
              <div className="tata-capital-login-logo">
                <img
                  src={"assets/images/TataCapitalLogo.svg"}
                  alt="TataCapitalLogo"
                  onClick={() => { window.open('https://www.tatacapital.com/') }}
                />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
